{
  "people": "Personas",
  "teams": "Equipos",
  "surnameAlphabetical": "Apellido A-Z",
  "teamsAlphabetical": "Equipos A-Z",
  "addTeamMember": "Agregar miembro del equipo",
  "addSelectedToTeam": "Agregar el seleccionado al equipo",
  "allPeople": "Todas las personas",
  "removeTeamLeaderMessage": "Esta persona ya no podrá editar ni añadir o eliminar miembros del equipo.",
  "removeTeamLeader": "Eliminar el estado de líder de equipo",
  "addTeamLeaderMessage": "Esta persona podrá editar y añadir o eliminar miembros del equipo.",
  "addTeamLeader": "Añadir el estado de líder de equipo",
  "add_people": {
    "add_user": "Agregar usuario",
    "invite_people_to_the_project": "Envía invitaciones para unirte al proyecto",
    "email": "Correo electrónico",
    "team": "Equipo",
    "separate_comma": "Separe las direcciones múltiples con una coma",
    "add_invitee_team": "Agrega invitados a un equipo",
    "add_more": "Añadir más",
    "project_admin": "Administrador del proyecto",
    "sso": "Habilitar el SSO"
  },
  "remove_people": {
    "remove_user": "Eliminar usuario",
    "remove_user_title": "Eliminar este usuario del proyecto",
    "remove_user_message": "Esto deshabilitará la cuenta del usuario seleccionado en el proyecto y ya no podrá iniciar sesión.",
    "remove_user_message_continue": "¿Está seguro de que desea continuar?",
    "remove_people_success": "El usuario se ha eliminado correctamente del proyecto"
  },
  "reset_password": {
    "reset_password_title": "Enviar enlace para restablecer la contraseña",
    "reset_password_message": "Esto enviará un enlace para restablecer la contraseña a las personas que hayas seleccionado.",
    "reset_password_message_continue": "¿Quieres continuar?",
    "reset_password_success": "El enlace para restablecer la contraseña se envió correctamente a las personas seleccionadas"
  },
  "sso": {
    "title": "Habilita el SSO",
    "confirm": "Esto habilitará el inicio de sesión único para las personas seleccionadas.",
    "continue": "¿Quieres continuar?",
    "success": "El SSO se habilitó correctamente para personas seleccionadas"
  },
  "sso_disable": {
    "title": "Desactiva el SSO",
    "confirm": "Los usuarios seleccionados ya no podrán iniciar sesión mediante el inicio de sesión único y deberán autenticarse con una contraseña.",
    "continue": "¿Desea continuar?",
    "success": "El inicio de sesión único se ha desactivado correctamente para personas seleccionadas"
  },
  "removeFromTeamMessage1": "Esta persona dejará de formar parte del equipo y perderá todos los permisos de visualización y edición asociados a ese equipo.",
  "removeFromTeamMessage2": "¿Estás seguro de que quieres continuar?",
  "removeFromTeamTitle": "Elimina a esta persona del equipo",
  "removeFromTeamOverflowOption": "Eliminar del equipo",
  "createANewTeam": "Crea un equipo nuevo",
  "nameOfTeam": "Nombre del equipo",
  "createNewTeam": "Crear un nuevo equipo",
  "teamLeader": "Líder de equipo",
  "toasts": {
    "add_team_success": "Equipo creado con éxito",
    "add_team_error": "No se pudo crear el equipo",
    "invite_success": "Las invitaciones se enviaron correctamente",
    "invite_error": "No se pudo enviar la invitación porque {{ reason }}",
    "removeFromTeamSuccess": "Se ha eliminado correctamente del equipo",
    "removeFromTeamError": "No se pudo eliminar del equipo",
    "setTeamLeaderSuccess": "Se estableció correctamente el estado de líder del equipo",
    "setTeamLeaderError": "No se pudo establecer el estado de líder del equipo",
    "deleteTeamSuccess": "El equipo se ha eliminado correctamente",
    "deleteTeamError": "No se pudo eliminar el equipo"
  },
  "amount_teams_selected": "{{ amount }} Equipos seleccionados",
  "invalid_email_address": "Dirección de correo electrónico no válida",
  "one_or_more_email_not_valid": "Uno o más correos electrónicos no son válidos",
  "select_one_team": "Selecciona uno o más equipos",
  "deleteTeamTitle": "Eliminar equipo",
  "deleteTeamMessage": "¿Estás seguro de que quieres eliminar el equipo: {{ team }}"
}